import React, { useEffect, useState } from 'react';
import { Box, Card, Grid, Typography, CircularProgress } from '@mui/joy';
import axios from 'axios';
import domain from "../../../util/domain";

export default function OverallStats() {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await axios.get(`${domain}/frontoffice/feedback/stats`);
                setStats(response.data);
            } catch (error) {
                console.error('Error fetching stats:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, []);

    if (loading) return <CircularProgress />;

    const formatStat = (key, value) => {
        if (key.startsWith('avg_')) {
            return Number(value).toFixed(2);
        }
        return value;
    };

    const getStatLabel = (key) => {
        const labels = {
            total_responses: 'Total Responses',
            unique_respondents: 'Unique Respondents',
            avg_response_rating: 'Avg Response Rating',
            avg_counsellor_clarity: 'Avg Counsellor Clarity',
            avg_additional_info_needed: 'Avg Additional Info Needed',
            positive_responses: 'Positive Responses',
            clear_explanations: 'Clear Explanations',
            info_requests: 'Info Requests'
        };
        return labels[key] || key.split('_').map(word =>
            word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ');
    };

    return (
        <Grid container spacing={2}>
            {stats && Object.entries(stats).map(([key, value]) => (
                <Grid xs={12} sm={6} md={4} key={key}>
                    <Card
                        variant="outlined"
                        sx={{
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 1,
                            bgcolor: 'background.surface'
                        }}
                    >
                        <Typography level="title-md" textAlign="center">
                            {getStatLabel(key)}
                        </Typography>
                        <Typography
                            level="h2"
                            sx={{
                                color: key.includes('avg_') ? 'primary.main' : 'text.primary'
                            }}
                        >
                            {formatStat(key, value)}
                        </Typography>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
} 